import { Component } from '@angular/core';
import {Router} from "@angular/router";
import {UserService} from "../../services/user.service";
import {AccountService} from "../../services/account.service";

@Component({
  selector: 'accounts',
  templateUrl: 'accounts.html'
})

export class AccountsComponent{
    constructor(
        private userService: UserService,
        private accountsService: AccountService,
        public router: Router
    ) { };

    isAdmin(): boolean {
      if (!this.userService.isSuper) {
        this.router.navigate(['/dashboard']);
      }
      return this.userService.isSuper;
    }
    accountRole = this.userService.accountRole;
}



// WEBPACK FOOTER //
// ./src/app/components/accounts/accounts.component.ts